// HM-302 demo: scala tipografica Inter Variable da SPEC v2.6 FINALE.
// Routata in HM-307 a /dev/typography.

const scale = [
  { cls: 'text-5xl font-bold tracking-hm-tight', label: 'text-5xl 48/1 — KPI hero' },
  { cls: 'text-4xl font-bold tracking-hm-tight', label: 'text-4xl 36/40 — h1 page title' },
  { cls: 'text-3xl font-semibold tracking-hm-tight', label: 'text-3xl 30/36 — h2 section' },
  { cls: 'text-2xl font-semibold tracking-hm-tight', label: 'text-2xl 24/32 — h3 sub' },
  { cls: 'text-xl font-medium', label: 'text-xl 20/28 — h4' },
  { cls: 'text-lg', label: 'text-lg 18/28 — body large, intro' },
  { cls: 'text-base', label: 'text-base 16/24 — body default' },
  { cls: 'text-sm', label: 'text-sm 14/20 — body small, label' },
  { cls: 'text-xs', label: 'text-xs 12/16 — meta info' },
];

const weights = [
  { name: 'font-normal (400)', cls: 'font-normal' },
  { name: 'font-medium (500)', cls: 'font-medium' },
  { name: 'font-semibold (600)', cls: 'font-semibold' },
  { name: 'font-bold (700)', cls: 'font-bold' },
];

export function TypographyDemo() {
  return (
    <div className="min-h-screen bg-bg-base p-8 text-text-primary">
      <h1 className="text-3xl font-bold mb-2">Tipografia — Inter Variable</h1>
      <p className="text-text-secondary mb-8">
        SPEC v2.6 FINALE. Font UNICO Inter da Google Fonts, optical sizing automatico per sizes
        &gt;24px. Letter-spacing -0.01em sui titoli.
      </p>

      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-4">Scala</h2>
        <div className="space-y-4 bg-bg-card rounded-lg p-6 shadow-hm-sm">
          {scale.map((item) => (
            <div key={item.cls} className={item.cls}>
              {item.label}
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-4">Pesi</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {weights.map((w) => (
            <div key={w.name} className="bg-bg-card rounded-lg p-6 shadow-hm-sm">
              <div className="text-sm text-text-secondary mb-2">{w.name}</div>
              <div className={`text-2xl ${w.cls} tracking-hm-tight`}>Hotel Mik · Camera 304</div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Esempio applicato</h2>
        <div className="bg-bg-card rounded-lg p-8 shadow-hm-md">
          <div className="text-sm text-text-secondary uppercase tracking-wider mb-2">
            Incasso oggi
          </div>
          <div className="text-5xl font-bold text-accent-primary-text tracking-hm-tight">
            € 1.247,80
          </div>
          <div className="text-sm text-text-muted mt-2">
            12 transazioni · scontrino medio € 103,98
          </div>
        </div>
      </section>
    </div>
  );
}
